import { action, ActionType } from 'typesafe-actions';
import { Money } from 'shared/types/common';
import { Investment_IdeaType } from 'types/common';
import { Stocks_StockType } from '../../__generated__/globalTypes';

export const TOGGLE_FIRST_LOGIN_MODAL = 'FIRST_LOGIN_MODAL/TOGGLE';

export const START_ORDER_SUBMIT_FLOW = 'START_ORDER_SUBMIT_FLOW';
export const SHOW_ORDER_SUBMIT_MODAL = 'ORDER_SUBMIT_MODAL/SHOW';
export const HIDE_ORDER_SUBMIT_MODAL = 'ORDER_SUBMIT_MODAL/HIDE';
export const SHOW_ORDER_SUBMITTED_MODAL = 'ORDER_SUBMITTED_MODAL/SHOW';
export const HIDE_ORDER_SUBMITTED_MODAL = 'ORDER_SUBMITTED_MODAL/HIDE';
export const SHOW_SELL_MODAL = 'POSITION_SELL_MODAL/SHOW';
export const HIDE_SELL_MODAL = 'POSITION_SELL_MODAL/HIDE';

export const SHOW_SELL_SUBMITTED_MODAL = 'SELL_SUBMITTED_MODAL/SHOW';
export const HIDE_SELL_SUBMITTED_MODAL = 'SELL_SUBMITTED_MODAL/HIDE';
export const SHOW_POSITION_DETAIL_MODAL = 'POSITION_DETAIL_MODAL/SHOW';
export const HIDE_POSITION_DETAIL_MODAL = 'POSITION_DETAIL_MODAL/HIDE';
export const SHOW_WITHDRAW_MODAL = 'WITHDRAW_MODAL/SHOW';
export const HIDE_WITHDRAW_MODAL = 'WITHDRAW_MODAL/HIDE';
export const SHOW_WITHDRAW_SUBMITTED_MODAL = 'WITHDRAW_SUBMITTED_MODAL/SHOW';
export const HIDE_WITHDRAW_SUBMITTED_MODAL = 'WITHDRAW_SUBMITTED_MODAL/HIDE';
export const SHOW_EXCHANGE_MODAL = 'EXCHANGE_MODAL/SHOW';
export const HIDE_EXCHANGE_MODAL = 'EXCHANGE_MODAL/HIDE';
export const TOGGLE_ACCOUNT_MESSAGE_TRANSFER_SUCCESS = 'TOGGLE_ACCOUNT_MESSAGE_TRANSFER_SUCCESS';

export const HIDE_LOGIN_WITH_2FA_RECOMENDATION = 'LOGIN_WITH_2FA_RECOMENDATION/HIDE';

export interface OrderSubmitModalParams {
  ideaId: number;
  productType: Investment_IdeaType | null;
  ideaName: string;
  enterAmount: Money;
  balance: number;
}

export type SellModalDomains = 'STOCK' | 'IDEA';
export type DetailModalDomains = 'STOCK' | 'IDEA';

export const actions = {
  startOrderSubmitFlow: (ideaId: number) => action(START_ORDER_SUBMIT_FLOW, { ideaId }),

  showOrderSubmitModal: (ideaId: number) => action(SHOW_ORDER_SUBMIT_MODAL, { ideaId }),
  hideOrderSubmitModal: () => action(HIDE_ORDER_SUBMIT_MODAL),

  showOrderSubmittedModal: (productType: Stocks_StockType | Investment_IdeaType | null) =>
    action(SHOW_ORDER_SUBMITTED_MODAL, { productType }),
  hideOrderSubmittedModal: () => action(HIDE_ORDER_SUBMITTED_MODAL),

  toggleFirstLoginModal: (visible: boolean) => action(TOGGLE_FIRST_LOGIN_MODAL, { visible }),

  showSellModal: (positionId: number, domain: SellModalDomains) =>
    action(SHOW_SELL_MODAL, { positionId, domain }),
  hideSellModal: () => action(HIDE_SELL_MODAL),

  showSellSubmittedModal: (amount: Money) => action(SHOW_SELL_SUBMITTED_MODAL, { amount }),
  hideSellSubmittedModal: () => action(HIDE_SELL_SUBMITTED_MODAL),

  showDetailModal: (positionId: number, domain: DetailModalDomains) =>
    action(SHOW_POSITION_DETAIL_MODAL, { positionId, domain }),
  hideDetailModal: () => action(HIDE_POSITION_DETAIL_MODAL),

  showWithdrawModal: () => action(SHOW_WITHDRAW_MODAL),
  hideWithdrawModal: () => action(HIDE_WITHDRAW_MODAL),

  showWithdrawSubmittedModal: () => action(SHOW_WITHDRAW_SUBMITTED_MODAL),
  hideWithdrawSubmittedModal: () => action(HIDE_WITHDRAW_SUBMITTED_MODAL),
  showExchangeModal: (currency: string, amount?: number) =>
    action(SHOW_EXCHANGE_MODAL, { currency, amount }),
  hideExchangeModal: () => action(HIDE_EXCHANGE_MODAL),
  hideLoginWith2FARecomendation: () => action(HIDE_LOGIN_WITH_2FA_RECOMENDATION),
};

export type Action = ActionType<typeof actions>;
